
import React, { useState } from 'react';
import { Dialog, DialogContent } from "@/components/ui/dialog";
import { ChevronLeft, ChevronRight, X } from 'lucide-react';

interface ImageModalProps {
  images: string[];
  initialIndex: number;
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

const ImageModal: React.FC<ImageModalProps> = ({
  images,
  initialIndex,
  open,
  onOpenChange
}) => {
  const [currentIndex, setCurrentIndex] = useState(initialIndex);
  
  const goToNext = () => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
  };
  
  const goToPrevious = () => {
    setCurrentIndex((prevIndex) => (prevIndex - 1 + images.length) % images.length);
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-4xl p-0 bg-black/90 border-none">
        <div className="relative w-full h-full flex items-center justify-center">
          <button 
            onClick={() => onOpenChange(false)} 
            className="absolute top-2 right-2 z-50 bg-black/40 text-white p-1.5 rounded-full hover:bg-black/60 transition-colors"
            aria-label="Close"
          >
            <X className="h-5 w-5" />
          </button>
          
          {images.length > 1 && (
            <>
              <button 
                onClick={goToPrevious}
                className="absolute left-2 top-1/2 transform -translate-y-1/2 bg-black/40 text-white p-2 rounded-full hover:bg-black/60 transition-colors"
                aria-label="Previous image"
              >
                <ChevronLeft className="h-6 w-6" />
              </button>
              
              <button 
                onClick={goToNext}
                className="absolute right-2 top-1/2 transform -translate-y-1/2 bg-black/40 text-white p-2 rounded-full hover:bg-black/60 transition-colors"
                aria-label="Next image"
              >
                <ChevronRight className="h-6 w-6" />
              </button>
            </>
          )}
          
          <div className="w-full aspect-video flex items-center justify-center">
            <img 
              src={images[currentIndex]} 
              alt={`Enlarged view ${currentIndex + 1}`} 
              className="max-h-[80vh] max-w-full object-contain"
            />
          </div>
          
          <div className="absolute bottom-4 left-0 right-0 flex justify-center gap-1.5">
            {images.length > 1 && images.map((_, index) => (
              <button
                key={index}
                onClick={() => setCurrentIndex(index)}
                className={`w-2 h-2 rounded-full transition-all ${
                  index === currentIndex ? "bg-white scale-110" : "bg-white/50"
                }`}
                aria-label={`Go to image ${index + 1}`}
              />
            ))}
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default ImageModal;
